export default "__VITE_ASSET__BrVUFxmg__"